"use client";

import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox";
import { CheckIcon, MinusIcon } from "lucide-react";

import { cn } from "@/lib/utils";

function Checkbox({ className, ...props }: CheckboxPrimitive.Root.Props) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "group flex h-5 w-5 shrink-0 items-center justify-center rounded border border-input bg-background outline-none transition-colors",
        "focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1",
        "data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground",
        // Partially-selected state (old MUI indeterminate): filled square with a dash.
        "data-indeterminate:border-primary data-indeterminate:bg-primary data-indeterminate:text-primary-foreground",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {/* Base UI mounts the indicator for checked AND indeterminate; pick the glyph by state.
          `keepMounted` + scale/fade lets the glyph pop in and out instead of snapping. */}
      <CheckboxPrimitive.Indicator
        keepMounted
        className="flex items-center justify-center text-current transition-[transform,opacity] duration-150 ease-out data-unchecked:scale-50 data-unchecked:opacity-0"
      >
        <MinusIcon className="hidden h-3.5 w-3.5 group-data-indeterminate:block" strokeWidth={3} />
        <CheckIcon className="hidden h-3.5 w-3.5 group-data-checked:block" strokeWidth={3} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
